<script setup>
import ResponsiveView from "@/components/helper/ResponsiveView.vue";

import RankingMobile from "../components/ranking/RankingMobile.vue";
import RankingSidebarMobile from "@/components/ranking/RankingSidebarMobile.vue";
</script>

<template>
  <ResponsiveView mobile-only>
    <RankingMobile />
  </ResponsiveView>
  <ResponsiveView desktop-only>
    <RankingSidebarMobile />
  </ResponsiveView>
</template>
